import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getNotifications(parkId, { unreadOnly = false } = {}) {
  const params = unreadOnly ? '?unreadOnly=true' : ''
  const response = await fetch(`${API_BASE}/parks/${parkId}/notifications${params}`)
  if (!response.ok) throw new Error('Error al obtener las notificaciones')
  return response.json()
}

export async function markNotificationRead(parkId, notificationId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/notifications/${notificationId}/read`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al marcar la notificación como leída')
  return response.json()
}

export async function markAllNotificationsRead(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/notifications/mark-all-read`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al marcar todas las notificaciones como leídas')
  return response.json()
}